<script>
	import { isPortraitScreen, pageOffset } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';

	let _ballon;
	let portrait;

	let animation = (value) => {
		animateElement(value, _ballon, (currentPageOffset) => {
			const scrolledStartSectionPercentage = currentPageOffset * 0.2;
			_ballon.style.transform = `translateX(${scrolledStartSectionPercentage * -1}%) translateY(-${scrolledStartSectionPercentage * 0.2}%)`;
		});
	};

	let prepareScene = () => {
		if (!_ballon) {
			requestAnimationFrame(prepareScene);
			return;
		}

		pageOffset.subscribe(animation);
		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
	};

	prepareScene();

</script>

<style>
	#ballon {
		position: absolute;
		left: 1em;
	}
	svg {
		position: absolute;
		width: auto;
		height: 9em;
		right: 0;
		top: 5em;
		overflow: visible;
	}

	svg.portrait {
		width: auto;
		height: 5em;
		top: 2em;
	}
</style>

<svg class:portrait width="100%" height="196" viewBox="0 0 100 196" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g id="ballon" bind:this={_ballon}>
		<path d="M68.9457 155.884H28.7146V196H68.9457V155.884Z" fill="#008B60"/>
		<path d="M0.60791 48.1757C0.60791 74.7365 48.922 145.809 48.922 145.809C48.922 145.809 97.2361 74.7365 97.2361 48.1757C97.0524 21.615 75.559 0 48.922 0C22.2849 0 0.60791 21.615 0.60791 48.1757Z" fill="#5A97C3"/>
	</g>
</svg>
